import { FormControl, TextField, Theme, withStyles } from '@material-ui/core';

export const CustomTextField = withStyles(() => ({
  root: {},
}))(TextField);

export const CustomFormControl = withStyles(
  ({ breakpoints, spacing }: Theme) => ({
    root: {
      width: '100%',
      [breakpoints.up('lg')]: {
        marginRight: spacing(4),
        width: 300,
      },
    },
  })
)(FormControl);
